function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\uD83C\uDF08 COLOR");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-icons-/-users-alt",
  transform: "translate(-1.000000, -3.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M12.3,12.22 C13.3796492,11.2854514 14.0000156,9.92794377 14,8.49999999 C14,5.73857624 11.7614237,3.49999999 8.99999999,3.49999999 C6.23857625,3.49999999 3.99999999,5.73857624 3.99999999,8.49999999 C3.99998439,9.92794377 4.6203508,11.2854514 5.69999999,12.22 C2.84094095,13.5146379 1.00300609,16.3614817 0.999999989,19.5 C0.999999989,20.0522848 1.44771524,20.5 1.99999999,20.5 C2.55228474,20.5 2.99999999,20.0522848 2.99999999,19.5 C2.99999999,16.1862915 5.68629149,13.5 8.99999999,13.5 C12.3137085,13.5 15,16.1862915 15,19.5 C15,20.0522848 15.4477153,20.5 16,20.5 C16.5522848,20.5 17,20.0522848 17,19.5 C16.9969939,16.3614817 15.159059,13.5146379 12.3,12.22 L12.3,12.22 Z M8.99999999,11.5 C7.34314575,11.5 5.99999999,10.1568542 5.99999999,8.49999999 C5.99999999,6.84314575 7.34314575,5.49999999 8.99999999,5.49999999 C10.6568542,5.49999999 12,6.84314575 12,8.49999999 C12,9.29564947 11.6839295,10.0587112 11.1213203,10.6213203 C10.5587112,11.1839295 9.79564947,11.5 8.99999999,11.5 Z M18.74,11.82 C20.0472579,10.3478927 20.3689573,8.24567904 19.5617649,6.44999989 C18.7545726,4.65432074 16.9687617,3.49947343 15,3.49999981 C14.4477153,3.49999981 14,3.94771524 14,4.49999981 C14,5.05228474 14.4477153,5.49999981 15,5.49999981 C16.6568543,5.49999981 18,6.84314575 18,8.49999981 C17.9971202,9.5689103 17.4257091,10.5555468 16.5,11.09 C16.1985079,11.263907 16.0091273,11.5820664 16,11.93 C15.9914951,12.275125 16.1616073,12.6002284 16.45,12.79 L16.84,13.05 L16.97,13.12 C19.4310752,14.2872862 20.9915345,16.7762188 20.97,19.4999998 C20.97,20.0522848 21.4177153,20.4999998 21.97,20.4999998 C22.5222848,20.4999998 22.97,20.0522848 22.97,19.4999998 C22.9866208,16.3798293 21.3859626,13.4736696 18.74,11.82 L18.74,11.82 Z",
  id: "\\uD83C\\uDF08-COLOR"
})));

var SvgUsersAlt = function SvgUsersAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "22px",
    height: "18px",
    viewBox: "0 0 22 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUsersAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/users-alt.86a39ac8.svg";
export { ForwardRef as ReactComponent };